import { Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

@Pipe({
  name: 'avantoTitleCase'
})
export class AvantoTitleCasePipe  extends TitleCasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value; // safeguard

    //%ic = IGNORE CAPITALIZATION
    if(value.startsWith('%ic')){
      //We remove the first 3 characters of the string (%ic) and return it as it is
      return value.substr(3);
    }

    //No special cases
    return super.transform(value);
  }

}